// src/components/kuestion/student/StudentApp.jsx
// Mounted at /student/*. Student token only (contract §9.3).
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useStudentAuth } from '../../../context/StudentAuthContext';
import { ThemeProvider } from '../shared/ThemeContext';
import { PreferencesProvider, usePreferences } from '../shared/PreferencesContext';
import StudentDashboard from './StudentDashboard';
import ExamRunner from './ExamRunner';
import { kq } from '../../../config/routes';
import '../campus.css';

// Route guard: no student session → login. Examiner sessions are not
// accepted here; a student token is a different audience.
export const StudentRoute = ({ children }) => {
  const { isStudent } = useStudentAuth();
  if (!isStudent) return <Navigate to={kq('login')} replace />;
  return children;
};

// Students carry their own preferences (contract §3.1 adds the org default).
function StudentRoutes() {
  const p = usePreferences();
  return (
    // Only the dashboard re-renders on a zone change. The runner is never
    // remounted: a sitting in progress must not be restarted by a menu click.
    <Routes>
      <Route index element={<StudentDashboard key={p ? p.version : 0} />} />
      <Route path="exam/:id" element={<ExamRunner />} />
      <Route path="*" element={<Navigate to={kq('student')} replace />} />
    </Routes>
  );
}

export default function StudentApp() {
  const { student, logout } = useStudentAuth();
  return (
    <ThemeProvider>
      <PreferencesProvider token={student?.token} onInvalidToken={logout}>
        <StudentRoutes />
      </PreferencesProvider>
    </ThemeProvider>
  );
}
